'use client'
import * as React from 'react'

import {
  SidebarContent,
  SidebarGroup,
  SidebarSeparator,
  SidebarTrigger,
} from '@/components/ui/sidebar'

import { Checkbox } from '@/components/ui/checkbox'
import { Accordion } from '@/components/ui/accordion'

import { EducationalLevelAccordion } from './sections/educational-level'
import { RegionAccordion } from './sections/region'
import { MemberAccordion } from './sections/member'
// import { UniversityAccordion } from './sections/university'
import { RewardAccordion } from './sections/reward'
import { SortbySection } from './sections/sortby'
import { useContestPreferenceStore } from '@/stores/contest-preference-store'
// import { InternationalAccordion } from './sections/international'

export function AppSidebarContent() {
  const store = useContestPreferenceStore()

  return (
    <>
      <SidebarSeparator className="mx-0 h-[0.5px] bg-black" />
      <SidebarContent>
        <SidebarGroup className="py-6">
          <Accordion type="multiple">
            <EducationalLevelAccordion
              educationalLevels={store.educationalLevels}
              setEducationalLevels={store.setEducationalLevels}
            />
            <RegionAccordion
              regions={store.regions}
              setRegions={store.setRegions}
            />
            <MemberAccordion
              memberTypes={store.memberTypes}
              setMemberTypes={store.setMemberTypes}
              setTeamNumberMax={store.setTeamNumberMax}
              setTeamNumberMin={store.setTeamNumberMin}
            />
            {/* <UniversityAccordion/> */}
            <RewardAccordion
              certificate={store.certificate}
              companyPartnership={store.companyPartnership}
              internship={store.internship}
              isBooleanOptionActive={store.isBooleanOptionActive}
              isPrizeSliderActive={store.isPrizeSliderActive}
              publishWork={store.publishWork}
              setCertificate={store.setCertificate}
              setCompanyPartnership={store.setCompanyPartnership}
              setInternship={store.setInternship}
              setIsBooleanOptionActive={store.setIsBooleanOptionActive}
              setIsPrizeSliderActive={store.setIsPrizeSliderActive}
              setPrizeNumberMax={store.setPrizeNumberMax}
              setPrizeNumberMin={store.setPrizeNumberMin}
              setPublishWork={store.setPublishWork}
              setTrophy={store.setTrophy}
              trophy={store.trophy}
            />
            {/* <InternationalAccordion /> */}
          </Accordion>
          <SortbySection
            setSortBy={store.setSortBy}
            setSortOrder={store.setSortOrder}
          />
          <div className="items-top mt-[31px] flex space-x-2 px-3">
            <Checkbox id="terms1" />
            <div className="grid gap-1.5 leading-none">
              <label
                htmlFor="terms1"
                className="text-sm font-bold leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                จดจำ preference ทุกครั้ง
              </label>
              <p className="text-sm text-muted-foreground">
                หากไม่เลือกการตั้งค่านี้ ระบบจะ Reset การกรองไปสู่ปกติ
              </p>
            </div>
          </div>
          <div className="mt-[25px] flex w-auto cursor-pointer items-center justify-center rounded-full bg-black px-4 py-2 text-[14px]">
            <SidebarTrigger asChild className="font-bold text-white">
              <button className="w-full font-bold text-white">
                Apply Filter
              </button>
            </SidebarTrigger>
          </div>
        </SidebarGroup>
      </SidebarContent>
    </>
  )
}
